import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { getMedicineNameStage, getTestingstageTaskOnTask } from '../../api/chatApi/chatApi'
import { useLocation } from 'react-router-dom';
import RatingDialog from '../../components/Chat/RatingDialog'
import CustomButton from '../../components/common/CustomButton'
import CustomHeader1 from '../../components/common/CustomHeader1'
import Slot from '../../components/common/Slots/Slot'
import SlotContainerMasonry from '../../components/common/Slots/SlotContainerMasonry'
import TooltipDialog from '../../components/common/TooltipDialog'
import MainLayout from '../../components/Layout/MainLayout'
import useDiagnosisTypes from '../../hooks/diagnosis/useDiagnosisTypes'
import useTooltipState from '../../hooks/useTooltipState'
import { SagaActionType } from '../../store/sagas/sagaActions'
import { RoutePath } from '../../types'
import CompetingClinicalDiagnosisField from '../../components/PageBlocks/ClinicalDiagnosis/CompetingClinicalDiagnosisField'
import ComplicationClinicalDiagnosisField from '../../components/PageBlocks/ClinicalDiagnosis/ComplicationClinicalDiagnosisField'
import AccompanyingClinicalDiagnosisField from '../../components/PageBlocks/ClinicalDiagnosis/AccompanyingClinicalDiagnosisField'
import MainClinicalDiagnosisField from '../../components/PageBlocks/ClinicalDiagnosis/MainClinicalDiagnosisField'
import chatApi from '../../api/chatApi'
import useIncreaseTaskStage from "../../hooks/testingTask/useIncreaseTaskStage";
import TooltipAccordion from '../../components/TooltipAccordion'
import { usePointProcentStore } from './store'
import useTestingStage from '../../hooks/testingTask/useTestingStage';
import ChatTooltip from '../../components/Tooltips/ChatTooltip';

interface TooltipData {
  testingstage_id: number;
  name: string;
  job_hint: string;
  stage_hint: string;
  stage_hint_name: string;
  stage_hint_blue: string;
}

interface Stage {
  routePath: string
  routhPathCode: string
  activeStage: number
  code: string
  legend_id?: number
  testingstage_id: number
}


export default function PreliminaryClinicalDiagnosisPage() {
  const asyncStateDiagnosisTypes = useDiagnosisTypes()
  const diagnosisTypes = asyncStateDiagnosisTypes?.value
  const [status, setStatus] = useState<boolean>(false)
  const [open, setOpen] = React.useState(false)
  const [mainClinicalDiagnosis, setMainPreliminaryClinicalDiagnosis] = useState<any>()
  const [competingClinicalDiagnosis, setCompetingPreliminaryClinicalDiagnosis] = useState<any>()
  const [complicationClinicalDiagnosis, setComplicationPreliminaryClinicalDiagnosis] = useState<any>()
  const [accompanyingClinicalDiagnosis, setAccompanyingPreliminaryClinicalDiagnosis] = useState<any>()
  const [mainClinicalDiagnosisProceed, setMainClinicalDiagnosisProceed] = useState<any[]>()
  const [competingClinicalDiagnosisProceed, setCompetingClinicalDiagnosisProceed] = useState<any>()
  const [complicationClinicalDiagnosisProceed, setComplicationClinicalDiagnosisProceed] = useState<any>()
  const [accompanyingClinicalDiagnosisProceed, setAccompanyingClinicalDiagnosisProceed] = useState<any>()
  const getPointProcent = usePointProcentStore(state => state.getPoints)
  const [stages, setStages] = useState([]);
  const { routePath, routhPathCode, activeStage } = useNextStagePath(stages);
  const [loading, increase, setAsyncTaskStage] = useIncreaseTaskStage(RoutePath[routhPathCode], activeStage);
  const dispatch = useDispatch()
  const history = useHistory()
  const testingStage = useTestingStage()
  const location = useLocation();
  const [readyToSendDiagnosis, setReadyToSendDiagnosis] = useState<boolean>(false)
  const [taskProceedToggle, setTaskProceedToggle] = useState<boolean>(false)
  const [manualActiveStage, setManualActiveStage] = useState(false)
  const preDiagnosisStatus = true
  const [taskId, setTaskId] = useState<number>(0)
  const saveMainClinicalDiagnosis = (mainClinicalDiagnosis) => {
    setMainPreliminaryClinicalDiagnosis(mainClinicalDiagnosis)
    setReadyToSendDiagnosis(true)
  }
  const saveCompetingClinicalDiagnosis = (competingClinicalDiagnosis) => {
    setCompetingPreliminaryClinicalDiagnosis(competingClinicalDiagnosis)
    setReadyToSendDiagnosis(true)

  }
  const saveComplicationClinicalDiagnosis = (complicationClinicalDiagnosis) => {
    setComplicationPreliminaryClinicalDiagnosis(complicationClinicalDiagnosis)
    setReadyToSendDiagnosis(true)
  }
  const saveAccompanyingClinicalDiagnosis = (accompanyingClinicalDiagnosis) => {
    setAccompanyingPreliminaryClinicalDiagnosis(accompanyingClinicalDiagnosis)
    setReadyToSendDiagnosis(true)
  }

  useEffect(() => {
    dispatch({ type: SagaActionType.START_LOAD_DIAGNOSIS_FOMRMS })
  }, [dispatch])


  async function getHistoryStage() {
    try {
      const res = await chatApi.getTestingStageHistory()
      const result = res.result.find((el) => el.activeStageId === 5)
      if (result && (!stages || (stages && stages.length === 0))) {
        setManualActiveStage(true)
      } else {
        setManualActiveStage(false)
      }
    } catch (error) {
      console.log(error)
    }
  }

  async function setHistoryStage(testingStage) {
    try {
      await chatApi.setTestingStageHistory(testingStage)
    } catch (error) {
      console.log(error)
    }
  }

  useEffect(() => {
    getHistoryStage()
  }, [stages])

  const [currentStage, setCurrentStage] = useState<Stage | null>(null)

  async function fetchAllStages() {
    try {
      const result = await getTestingstageTaskOnTask();
      setStages(result.data.testingstage_task_on_task);
      const currentStage = result.data.testingstage_task_on_task.find((stage: Stage) => stage.routePath === '/preliminary_diagnosis');
      setCurrentStage(currentStage);
    } catch (error) {
      console.error('Ошибка при загрузке этапов:', error);
    }
  }

  useEffect(() => {
    fetchAllStages();
  }, []);

  const [medicineNameStage, setMedicineNameStage] = useState<string>('')

  async function getNameStage() {
    if (!taskId || !currentStage) {
      return
    }
    
    try {
      const result = await getMedicineNameStage({ task_id: taskId })
      
      if (result?.data?.MedicineNameStage) {
        const matchingStage = result.data.MedicineNameStage.find((item: any) => 
          item.testingstage_id === currentStage.testingstage_id
        )
        const stageName = matchingStage?.name
        setMedicineNameStage(stageName || '')
      } else {
        setMedicineNameStage('')
      }
    } catch (error) {
      console.error('Error fetching stage name:', error)
      setMedicineNameStage('')
    }
  }

  useEffect(() => {
    getNameStage()
  }, [taskId, currentStage])

  function useNextStagePath(stages) {
    const location = useLocation();
    const currentPath = location.pathname;
    if (!stages || stages.length === 0) {
      return { routePath: '', routhPathCode: '' };
    }
    const sortedStages = stages.sort((a, b) => a.activeStage - b.activeStage);
    const currentIndex = sortedStages.findIndex(stage => stage.routePath === currentPath);

    if (currentIndex !== -1 && currentIndex + 1 < sortedStages.length) {
      return {
        routePath: sortedStages[currentIndex + 1].routePath,
        routhPathCode: sortedStages[currentIndex + 1].routhPathCode,
        activeStage: sortedStages[currentIndex + 1].activeStage
      };
    }

    return { routePath: '', routhPathCode: '', activeStage: '' };
  }

  useEffect(() => {
    const getDialogStatus = async () => {
      try {
        const response = await chatApi.getSettingsPiloting();
        const statusValue = response?.result?.[0]?.value;
        setStatus(statusValue === 'true');
      } catch (error) {
        console.log('Не удалось получить настройки пилотинга', error)
        setStatus(false)
      }
    };

    void getDialogStatus();
  }, []);

  const [returnedStage, setReturnedStage] = useState<boolean>(false);

  function checkNextStage() {
    if (stages.length > 0) {
      const res = stages.find(el => el.routePath === location.pathname)
      let passedStage = 0
      if (res) {
        passedStage = stages.indexOf(res) + 1
      }
      if (testingStage > passedStage) {
        setReturnedStage(true)
      }
    }
  }

  useEffect(() => {
    checkNextStage()
  }, [activeStage])

  // Функция для перехода на следующий этап, если текущий этап уже пройден
  async function goToNextStage() {
    const currentPath = location.pathname;
    const currentStageObj = stages.find(stage => stage.routePath === currentPath);

    if (!currentStageObj) return;

    setHistoryStage(currentStageObj.activeStage);
    const currentActiveStage = currentStageObj.activeStage;

    const sortedNextStages = stages
      .filter(stage => stage.activeStage > currentActiveStage)
      .sort((a, b) => a.activeStage - b.activeStage);

    if (sortedNextStages.length === 0) {
      console.warn('Нет доступных следующих стадий.');
      return;
    }

    let nextIndex = 0;

    if (sortedNextStages[nextIndex].code === 'conclusion') {
      nextIndex += 1;

      if (nextIndex >= sortedNextStages.length) {
        nextIndex = 0;
      }
    }

    const finalNextStage = sortedNextStages[nextIndex];

    if (finalNextStage.legend_id) {
      history.push(RoutePath.legend);
    } else {
      history.push(finalNextStage.routePath);
    }
  }


  useEffect(() => {
    getPointProcent()
  }, [])

  const getTaskProceedData = async () => {
    try {
      const resultTaskProceed = await chatApi.getClinicalDiagnosisTaskProceed();
      if (resultTaskProceed && resultTaskProceed.result.length > 0) {
        setTaskProceedToggle(true);

        const mainDiagnoses = resultTaskProceed.result.filter(d => d.typeOfInformationLevelId === 4);
        const competingDiagnoses = resultTaskProceed.result.filter(d => d.typeOfInformationLevelId === 5);
        const complicationDiagnoses = resultTaskProceed.result.filter(d => d.typeOfInformationLevelId === 6);
        const accompanyingDiagnoses = resultTaskProceed.result.filter(d => d.typeOfInformationLevelId === 7);

        setMainClinicalDiagnosisProceed(mainDiagnoses.map(diagnosis => ({
          clinicalDiagnosis: diagnosis.clinicalDiagnosis.name,
          clinicalDiagnosisId: diagnosis.clinicalDiagnosisId,
          typeOfInformationLevelId: diagnosis.typeOfInformationLevelId
        })));

        setCompetingClinicalDiagnosisProceed(competingDiagnoses.map(diagnosis => ({
          clinicalDiagnosis: diagnosis.clinicalDiagnosis.name,
          clinicalDiagnosisId: diagnosis.clinicalDiagnosisId,
          typeOfInformationLevelId: diagnosis.typeOfInformationLevelId
        })));

        setComplicationClinicalDiagnosisProceed(complicationDiagnoses.map(diagnosis => ({
          clinicalDiagnosis: diagnosis.clinicalDiagnosis.name,
          clinicalDiagnosisId: diagnosis.clinicalDiagnosisId,
          typeOfInformationLevelId: diagnosis.typeOfInformationLevelId
        })));

        setAccompanyingClinicalDiagnosisProceed(accompanyingDiagnoses.map(diagnosis => ({
          clinicalDiagnosis: diagnosis.clinicalDiagnosis.name,
          clinicalDiagnosisId: diagnosis.clinicalDiagnosisId,
          typeOfInformationLevelId: diagnosis.typeOfInformationLevelId
        })));
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getTaskProceedData();
  }, []);


  useEffect(() => {
    getTaskProceedData()
  }, [])


  const saveClinicalDiagnosis = async () => {
    try {
      const allDiagnoses = [
        ...(mainClinicalDiagnosis || []),
        ...(competingClinicalDiagnosis || []),
        ...(complicationClinicalDiagnosis || []),
        ...(accompanyingClinicalDiagnosis || []),
      ];

      const validDiagnoses = allDiagnoses.filter(diagnosis => diagnosis && diagnosis.clinicalDiagnosisId);

      if (validDiagnoses.length === 0) {
        console.log('Нет данных для сохранения');
        return;
      }

      await Promise.all(
        validDiagnoses.map(diagnosis =>
          chatApi.createClinicalDiagnosisTaskProceed(
            diagnosis.clinicalDiagnosisId,
            diagnosis.typeOfInformationLevelId,
            true
          )
        )
      );

      console.log('Клинические диагнозы успешно сохранены');
    } catch (error) {
      console.log('Ошибка при сохранении клинических диагнозов:', error);
    } finally {
      goToNextStage();
    }
  };
  const taskName = '19'

  useEffect(() => {
    getMedicineNameStages()
  }, [])

  async function unfinishedTaskHandler() {
    try {
      const response = await chatApi.unfinishedTask()
      setTaskId(response.result.taskId)
    } catch (err) {
      console.log('при выполнении unfinishedTaskHandler', err);
    }
  }

  useEffect(() => {
    unfinishedTaskHandler()
  }, [])

  const [tooltipText, setTootipText] = useState<TooltipData | null>(null)


  async function getMedicineNameStages() {
    try {
      const result = await getMedicineNameStage({ task_id: taskId })

      if (result.data.MedicineNameStage && result.data.MedicineNameStage.length > 0 && currentStage) {
        const stageHintElement = result.data.MedicineNameStage.find(el => el.testingstage_id === currentStage.testingstage_id)
        setTootipText(stageHintElement)
      }

    } catch (error) {
      console.log(error)
    }
  }

  const [tooltipState, openTooltip]: [any, any] = useTooltipState()

  return (
    <>
      {diagnosisTypes ? (
        <MainLayout
          title='Предварительный клинический диагноз'
          onClickTooltip={openTooltip}
        >

          {/* {open ? <RatingDialog open={open} onSubmit={hideRatingDialog} /> : null} */}
          <TooltipDialog {...tooltipState}>
            {currentStage && <ChatTooltip task_id={taskId} testingStageId={currentStage.testingstage_id} />}
          </TooltipDialog>
          {/* <TooltipAccordion taskName={taskName} taskId={taskId} currentStage={currentStage!} /> */}

          <div style={{ paddingBottom: `25px` }}>
            {taskProceedToggle ?
              <React.Fragment>
                <CustomHeader1>Предварительный клинический диагноз уже отправлен</CustomHeader1>
              </React.Fragment> :
              null}
            <React.Fragment>
              <SlotContainerMasonry>
                <Slot title={diagnosisTypes && diagnosisTypes[0]?.description} color='primary'>
                  <MainClinicalDiagnosisField
                    preDiagnosisStatus={preDiagnosisStatus}
                    saveMainClinicalDiagnosis={saveMainClinicalDiagnosis}
                    initialDiagnosis={mainClinicalDiagnosisProceed}
                    taskProceedToggle={taskProceedToggle}
                  />
                </Slot>
                <Slot title={diagnosisTypes && diagnosisTypes[1]?.description} color='primary'>
                  <CompetingClinicalDiagnosisField
                    preDiagnosisStatus={preDiagnosisStatus}
                    saveCompetingClinicalDiagnosis={saveCompetingClinicalDiagnosis}
                    initialDiagnosis={competingClinicalDiagnosisProceed}
                    taskProceedToggle={taskProceedToggle}
                  />
                </Slot>
                <Slot title={diagnosisTypes && diagnosisTypes[2]?.description} color='primary'>
                  <ComplicationClinicalDiagnosisField
                    preDiagnosisStatus={preDiagnosisStatus}
                    saveComplicationClinicalDiagnosis={saveComplicationClinicalDiagnosis}
                    initialDiagnosis={complicationClinicalDiagnosisProceed}
                    taskProceedToggle={taskProceedToggle}
                  />
                </Slot>
                <Slot title={diagnosisTypes && diagnosisTypes[3]?.description} color='primary'>
                  <AccompanyingClinicalDiagnosisField
                    preDiagnosisStatus={preDiagnosisStatus}
                    saveAccompanyingClinicalDiagnosis={saveAccompanyingClinicalDiagnosis}
                    initialDiagnosis={accompanyingClinicalDiagnosisProceed}
                    taskProceedToggle={taskProceedToggle}
                  />
                </Slot>
              </SlotContainerMasonry>
              {!taskProceedToggle ?
                <CustomButton
                  onClick={saveClinicalDiagnosis}
                  disabled={!readyToSendDiagnosis}
                >
                  Завершить шаг
                </CustomButton> :
                <CustomButton
                  onClick={goToNextStage}
                >
                  Следующий этап
                </CustomButton>}
            </React.Fragment>
          </div>
        </MainLayout>
      ) : (
        <p>Загрузка данных...</p>
      )}
    </>
  )
}


